import { DeviceState } from '../types';
import {Reducer} from "redux";
import { initialize, filterDevices, updateDevice, updateNotes, partnerDeviceList, filterPartnerDevices, getSensorsForUser } from '../Routines';
import uuid from 'uuid';

const deviceState: DeviceState = {
  devices: [],
  lastModifiedTime: 0,
  filteredDevices: [],
  deviceTypes: [],
  partnerDeviceList: [],
  filteredPartnerDeviceList: [],
  filteredPartnerDevicesInit: false,
  sensors: {}
};

const device: Reducer<DeviceState> = (state: DeviceState = deviceState, action) => {
  switch (action.type) {
    case initialize.SUCCESS:
      return {
        ...state,
        listKey: uuid(),
        devices: action.payload.devices,
        deviceTypes: action.payload.deviceTypes,
        lastModifiedTime: action.payload.lastModifiedTime
      };

    case filterDevices.SUCCESS:
      return{
        ...state,
        filteredDevices: action.payload
      }

    case updateDevice.SUCCESS:
    
      return{
        ...state,
        ...action.payload
      }

    case partnerDeviceList.SUCCESS:
      return{
        ...state,
        partnerDeviceList: action.payload
      }

    
    case updateNotes.SUCCESS:
      return{
        ...state,
        devices: action.payload
      }

    case filterPartnerDevices.SUCCESS:
      return{
        ...state,
        filteredPartnerDeviceList: action.payload,
        filteredPartnerDevicesInit: true
      }

    case getSensorsForUser.SUCCESS:
      return{
        ...state,
        sensors: action.payload
      }

    default:
      return state;
  }
};

export default device;
